import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <main className="bg-white min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0a1628] to-[#162447] py-16 pt-32">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl font-black text-white mb-3">Privacy Policy</h1>
          <p className="text-gray-300 text-sm">Last updated: March 28, 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">

          <section>
            <p className="text-base">
              Leak Detectives Las Vegas ("Company," "we," "us," or "our") operates this website and provides
              professional leak detection and plumbing services throughout Las Vegas, NV and Clark County.
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information when
              you visit our website or contact us for services. Please read it carefully.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">1. Information We Collect</h2>
            <p className="mb-3">We may collect the following types of information:</p>
            <ul className="list-disc pl-6 space-y-2 text-sm">
              <li><strong>Personal Identification Information:</strong> Name, phone number, email address, and home or service address when you submit a contact or estimate request form.</li>
              <li><strong>Service Information:</strong> Details about your plumbing issue, property type, and service history when you describe your needs.</li>
              <li><strong>Usage Data:</strong> Browser type, IP address, pages visited, time spent on pages, and referring URLs, collected automatically through standard server logs and analytics tools.</li>
              <li><strong>Communications:</strong> Records of calls, emails, or messages exchanged between you and our team.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">2. How We Use Your Information</h2>
            <p className="mb-3">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2 text-sm">
              <li>Respond to your service requests, questions, and estimate inquiries</li>
              <li>Schedule and coordinate plumbing or leak detection appointments</li>
              <li>Send service confirmations, follow-up communications, and invoices</li>
              <li>Improve our website, services, and customer experience</li>
              <li>Comply with applicable laws and regulations in the state of Nevada</li>
              <li>Send occasional promotional communications (you may opt out at any time)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">3. How We Share Your Information</h2>
            <p className="mb-3">We do not sell, trade, or rent your personal information to third parties. We may share your information in limited circumstances:</p>
            <ul className="list-disc pl-6 space-y-2 text-sm">
              <li><strong>Service Providers:</strong> Trusted vendors (scheduling software, payment processors, CRM platforms) who assist us in operating our business, bound by confidentiality agreements.</li>
              <li><strong>Legal Requirements:</strong> When required by law, court order, or governmental authority.</li>
              <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction.</li>
              <li><strong>With Your Consent:</strong> For any other purpose with your explicit consent.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">4. Cookies and Tracking Technologies</h2>
            <p className="text-sm">
              Our website may use cookies and similar tracking technologies to enhance your browsing experience,
              analyze site traffic, and understand where visitors come from. You can instruct your browser to
              refuse all cookies or to indicate when a cookie is being sent. However, some features of the
              website may not function properly without cookies.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">5. Data Security</h2>
            <p className="text-sm">
              We implement reasonable administrative, technical, and physical security measures to protect your
              personal information from unauthorized access, use, alteration, or disclosure. However, no method
              of transmission over the Internet or electronic storage is 100% secure. We cannot guarantee
              absolute security of your data.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">6. Third-Party Links</h2>
            <p className="text-sm">
              Our website may contain links to third-party websites (such as financing partners or review
              platforms). We are not responsible for the privacy practices of those sites and encourage you
              to review their privacy policies before providing any personal information.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">7. Children&apos;s Privacy</h2>
            <p className="text-sm">
              Our website and services are not directed to individuals under the age of 18. We do not
              knowingly collect personal information from children. If you believe a child has provided
              us with personal information, please contact us and we will promptly delete it.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">8. Nevada Privacy Rights</h2>
            <p className="text-sm">
              Nevada residents have the right to opt out of the sale of their personal information under
              Nevada Revised Statutes Chapter 603A. We do not sell personal information. If you have
              questions about our data practices, you may contact us using the information below.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">9. Changes to This Policy</h2>
            <p className="text-sm">
              We may update this Privacy Policy from time to time. We will notify you of any changes by
              posting the new policy on this page with an updated effective date. Your continued use of
              our website after any changes constitutes your acceptance of the revised policy.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#0f1f3d] mb-3">10. Contact Us</h2>
            <p className="text-sm mb-2">If you have any questions about this Privacy Policy, please contact us:</p>
            <div className="bg-gray-50 rounded-lg p-5 text-sm space-y-1">
              <p><strong>Leak Detectives Las Vegas</strong></p>
              <p>Las Vegas, NV &amp; Clark County</p>
              <p>Phone: <a href="tel:7252675482" className="text-cyan-600 hover:underline">(725) 267-5482</a></p>
            </div>
          </section>

        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to="/" className="text-cyan-600 hover:underline text-sm font-semibold flex items-center gap-1">
            <i className="ri-arrow-left-line"></i> Back to Home
          </Link>
          <Link to="/terms-of-service" className="text-cyan-600 hover:underline text-sm">
            View Terms of Service &rarr;
          </Link>
        </div>
      </div>
    </main>
  );
}
